
import { Component, OnInit, Inject, ElementRef, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { CommonService, AlertService, AdminService, LeadService } from '../../../_services/';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

import { emailList } from '../../../_helper/global';
import { Subscription } from 'rxjs';
// Algolia
import algoliasearch from 'algoliasearch';


@Component({
  selector: 'app-edit-contact-dialog',
  templateUrl: './edit-contact-dialog.component.html',
  styleUrls: ['./edit-contact-dialog.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  },
})
export class EditContactDialogComponent implements OnInit {
  editContactForm:FormGroup;
  submitted = false;
  showJobFunction:Boolean=false;
  errMsg:String = '';
  locations:any;
  showrooms:any;
  designerList:any=[];
  contactSourceList:any=[];
  // associalteList:any=[];
  contactTypeList:any=[];
  contactType:String='';
  jobFunctionList:any=[];
  showTypeField:Boolean=true;
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  private subscription4: Subscription;
  private subscription5: Subscription;
  constructor(
    public dialogRef: MatDialogRef<EditContactDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin:AdminService,
    private _lead:LeadService,
    private _toastr: ToastrService,
    private _eref:ElementRef
  ) { }

  ngOnInit() {
    // this.getContactDetail(this.data.id);
    this.jobFunctionList = this.data.jobFunctionList;
    
    const contactData = this.data.contactData; 
    
    this.contactType = contactData['contact_type_id'];
    if(contactData['job_functions']!=undefined){
      for(let i=0;i<this.jobFunctionList.length;i++){
        if(contactData['job_functions'].includes(this.jobFunctionList[i].id)){
          this.jobFunctionList[i].selected = true;
        }
      }
    }
    
    this.editContactForm = this.fb.group({
      contact_type_id:[contactData['contact_type_id'],[]],
      job_functions: this.buildJobFunctions(),
      first_name: [contactData['first_name'], [Validators.required]],
      last_name: [contactData['last_name'], []],
      mobile_phone :[contactData['mobile_phone'],[]],
      email : [contactData['email'],[]],
      address : [contactData['address'], []],
      // notes :[contactData['notes'],[]],
      showroom :[contactData['showroom_default_id'],[]],
      contact_source_id :[contactData['contact_source_id'],[]],
      owner_contact_id:[contactData['owner_contact_id'],[]],
      company : [contactData['company'], []],
    })
    if(emailList.includes(localStorage.getItem('rs-email'))){
      this.getDesignerList('all');
    } 
    else {
      this.getDesignerList(localStorage.getItem('uid'));
    }    

    this.getShowroomList();
    this.getcontactSourceList();
    this.getContactTypeList();
  }

  onClick(event) {
    const divSec = (<Element>event.target).className;
    if (!divSec.includes('location-area')) // or some similar check
      this.locations = [];
   }

  hideAddLeadDialog() {
    this.dialogRef.close();
  }

  get fval() {
    return this.editContactForm.controls;
  }

  // code to get the detail of contact to edit
  /*
  getContactDetail(id){
    this._lead.getContactDetail(id).subscribe(result=>{
      let contactData = result.payload.data();
      this.contactType = contactData['contact_type_id'];
      if(contactData['job_functions']!=undefined){
        for(let i=0;i<this.jobFunctionList.length;i++){
          if(contactData['job_functions'].includes(this.jobFunctionList[i].id)){
            this.jobFunctionList[i].selected = true;
          }
        }
      }
      // patch value in the form
      this.editContactForm.patchValue({ 
        contact_type_id: contactData['contact_type_id'],
        first_name: contactData['first_name'],
        last_name: contactData['last_name'],
        mobile_phone :contactData['mobile_phone'],
        email : contactData['email'],
        address : contactData['address'],
        description : contactData['description'],
        showroom : contactData['showroom'],
        contact_source_id : contactData['contact_source_id'],
        owner_contact_id: contactData['owner_contact_id']
      })

    },err=>{
      this.errMsg = err.message ? err.message : 'Something went wrong!';
    })
  }*/


  getSuggestions(event){
    this.subscription5 = this._admin.getSuggestions(event.target.value).subscribe(res => {
       this.locations = res["data"].map(item=>item.description);
    },err=>{
      this._common.showLoader(false);
      this.errMsg = err.message
    })   
  }

  setLocation(locationName){
    this.subscription5.unsubscribe();
    this.editContactForm.patchValue({address:locationName});
    this.locations =[];
  }

  removeLocation(){
    // this.locations =[];
  }

  showHideFields(event){
    this.showJobFunction = false;
    if(event.target.value==="staff"){
      this.showJobFunction = true;
    }
  }

  changeType(event){
    this.contactType= event.target.value;
  }

  // code for creating dynamic checkbox
  get job_functions() {
    return this.editContactForm.get('job_functions') as FormArray;
  };

  buildJobFunctions() {
    if(this.jobFunctionList && this.jobFunctionList.length>0){
      const arr = this.jobFunctionList.map((item) => {
        return this.fb.control(item.selected);
      }); 
      return this.fb.array(arr); 
    }
  }

  onFormSubmit(value):void {
    this.submitted = true;
    if(!this.editContactForm.value.first_name){
      alert('First Name is required');
    }
    if (this.editContactForm.invalid) {
      return;
    } 

    this._common.showLoader(true);
    
    let form = this.editContactForm.value;
    form.uid = localStorage.getItem('uid');
    if(form.showroom){
      for(let i=0; i<this.showrooms.length;i++){
        if(this.showrooms[i].payload.doc.id==form.showroom){
          form.showroom_default_id = form.showroom;
          form.showroom_default_name = this.showrooms[i].payload.doc.data().name;
          // const newArr = [{
          //   showroom_id : this.showrooms[i].payload.doc.id,
          //   showroom_name : this.showrooms[i].payload.doc.data().name
          // }]
          // form.showroom = newArr;
        }
      }
      delete form.showroom;
    }
    
    if(value.contact_type_id=="staff"){
      const f = Object.assign({}, value, {
     
        job_functions: value.job_functions.map((s, i) => {
          return {
            name: this.jobFunctionList[i].name,
            id: this.jobFunctionList[i].id,
            selected: s
          }
        })
        })
        let oldJobFunctions = f.job_functions.filter(doc=>{ if(doc.selected==true){ return doc}})
    
        form.job_functions = [];
        for(let i = 0; i < oldJobFunctions.length; i++) {
          form.job_functions.push(oldJobFunctions[i].id);
        }
    
    }
    
   
    // Update owner first name, last name if updated
    if(form.owner_contact_id !== this.data.contactData['owner_contact_id']){
      const newDesigner = this.designerList.find(item => item.payload.doc.id ===form.owner_contact_id)
      if(newDesigner && newDesigner != undefined){
        form.owner_user_id = newDesigner.payload.doc.data().user_id;
        form.owner_first_name = newDesigner.payload.doc.data().first_name;
        form.owner_last_name = newDesigner.payload.doc.data().last_name;
  
      }
    }
      
    this._lead.updateContact(form,this.data.id).then(res => {
      this._common.showLoader(false);
      this.dialogRef.close();
      this._toastr.success(`Contact edited successfully!`,"",{ timeOut: 4000 });  
    },err=>{
      this.dialogRef.close();
      this._common.showLoader(false);
      this.errMsg = "Something went wrong"
      this._toastr.error(`${this.errMsg}`,"",{ timeOut: 4000 });
    })
   
  }
  // get showroom list...
  getShowroomList(){
    this._common.showLoader(true);
    this.subscription = this._admin.geShowroomList().subscribe(result=>{
      this._common.showLoader(false);
      this.showrooms = result;
      
    },error=>{
      this._common.showLoader(false);
      this._alert.error('Something went wrong');
    })
  }

  // get designer list...
  getDesignerList(listType){
    this._common.showLoader(true);
    this.subscription2 = this._lead.getDesignerList(listType).subscribe(result=>{
      this._common.showLoader(false);
      this.designerList = result;
    },error=>{
      this._common.showLoader(false);
      this._alert.error('Something went wrong');
    })
  }

  // get contact source list
  getcontactSourceList(){
    // this._common.showLoader(true);
    this.subscription3 = this._admin.getContactSourceList().subscribe(result=>{
      // this._common.showLoader(false);
      this.contactSourceList = result;
    },error=>{
      this._common.showLoader(false);
      this._alert.error('Something went wrong');
    })
  }


  // get contacct type list...
  getContactTypeList(){
    // this._common.showLoader(true);
    this.subscription4 = this._admin.getContactTypeList().subscribe(result=>{
      // this._common.showLoader(false);
      this.contactTypeList = result;
    },error=>{
      this._common.showLoader(false);
      this._alert.error('Something went wrong');
    })
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.subscription2) this.subscription2.unsubscribe();
    if(this.subscription3) this.subscription3.unsubscribe();
    if(this.subscription4) this.subscription4.unsubscribe();
    if(this.subscription5) this.subscription5.unsubscribe();
  }

}
